import React, { useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import useWindowSize from '../../../hooks/useWindowSize';
import BudgetSmartBtn from '../../../images/BudgetSmartBtn.svg';
import BuiltSmartBtn from '../../../images/BuiltSmartBtn.svg';
import DesignSmartBtn from '../../../images/DesignSmartBtn.svg';
import EnergySmartBtn from '../../../images/EnergySmartBtn.svg';
import HouseSmartMobileLogo from '../../../images/HouseSmartLogoVertical.svg';
import HouseSmartLogo from '../../../images/HouseSmartTextLogo.svg';
import HouseSmartTopShape from '../../../images/HouseSmartTopShape.svg';
import HouseSmartTopVideoBackground from '../../../images/HouseSmartTopVideoBackground.jpg';
import PlayBtn from '../../../images/svg/icons/PlayBtn';
import { fireSegmentEvent } from '../../../utils';
import Modal from '../../Shared/SmokeyTransitional/components/Modal/Modal';
import { smoothScroll } from '../../Shared/SmokeyTransitional/utils/utils';
import WistiaVideoEmbed from '../SmokeyTransitional/components/WistiaVideoEmbed/WistiaVideoEmbed';
import HouseSmartTopStyles from './HouseSmartTop.styled';

export const HouseSmartTop = ({ isClayton }) => {
  const [ModalShowing, setModalShowing] = useState(false);
  const [width, height] = useWindowSize();
  const isMobile = width && width <= 1275;

  return (
    <HouseSmartTopStyles>
      <div className="container">
        <div className="content">
          <div className="content-inner">
            <img
              src={isMobile ? HouseSmartMobileLogo : HouseSmartLogo}
              alt="HouseSmart Logo with Text"
            />
            <p className="introduction">
              You’re putting a lot of thought into the right home for you. We
              are too. It’s how we create beautiful, affordable and strong homes
              with energy-efficient features. This is HouseSmart. It runs from
              initial design through final construction, but it begins and ends
              with you.
            </p>
            <div className="help-text">
              <svg
                width="17"
                height="20"
                viewBox="0 0 17 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M3.3431 9.88232C3.55057 9.6556 3.88693 9.6556 4.0944 9.88232L7.4375 13.5356L7.4375 3.3423C7.4375 3.02168 7.67535 2.76177 7.96875 2.76177C8.26215 2.76177 8.5 3.02168 8.5 3.3423L8.5 13.5356L11.8431 9.88232C12.0506 9.6556 12.3869 9.6556 12.5944 9.88232C12.8019 10.109 12.8019 10.4766 12.5944 10.7033L8.3444 15.3476C8.13693 15.5743 7.80057 15.5743 7.5931 15.3476L3.3431 10.7033C3.13563 10.4766 3.13563 10.109 3.3431 9.88232Z"
                  fill="#0075C9"
                />
              </svg>
              <p>Choose a category or continue scrolling</p>
            </div>
          </div>
        </div>
        <div
          className="video-box ga-housesmart-top-video"
          onClick={() => {
            setModalShowing(true) +
              fireSegmentEvent('Video Started', {
                eventContext: 'housesmart_hero_video',
                videoId: isClayton ? 'kq1zhev3ag' : 'xjffah803m',
              });
          }}
        >
          <LazyLoadImage
            alt="Dining room with furniture"
            effect="blur"
            src={HouseSmartTopVideoBackground}
          />
          <PlayBtn />
        </div>
        <div className="quick-links">
          <ul>
            <li
              className="ga-housesmart-smoothscroll-builtsmart"
              onClick={() => {
                smoothScroll('#BuiltSmart', 0) +
                  fireSegmentEvent('CTA Clicked', {
                    isNav: false,
                    type: 'button',
                    text: '',
                    eventContext: 'housesmart_hero_builtsmart',
                  });
              }}
            >
              <img src={BuiltSmartBtn} alt={'builtsmart icon'} />
            </li>
            <li
              className="ga-housesmart-smoothscroll-designsmart"
              onClick={() => {
                smoothScroll('#DesignSmart', 0) +
                  fireSegmentEvent('CTA Clicked', {
                    isNav: false,
                    type: 'button',
                    text: '',
                    eventContext: 'housesmart_hero_designsmart',
                  });
              }}
            >
              <img src={DesignSmartBtn} alt={'designsmart icon'} />
            </li>
            <li
              className="ga-housesmart-smoothscroll-energysmart"
              onClick={() => {
                smoothScroll('#EnergySmart', 0) +
                  fireSegmentEvent('CTA Clicked', {
                    isNav: false,
                    type: 'button',
                    text: '',
                    eventContext: 'housesmart_hero_energysmart',
                  });
              }}
            >
              <img src={EnergySmartBtn} alt={'energysmart icon'} />
            </li>
            <li
              className="ga-housesmart-smoothscroll-budgetsmart"
              onClick={() => {
                smoothScroll('#BudgetSmart', 0) +
                  fireSegmentEvent('CTA Clicked', {
                    isNav: false,
                    type: 'button',
                    text: '',
                    eventContext: 'housesmart_hero_budgetsmart',
                  });
              }}
            >
              <img src={BudgetSmartBtn} alt={'budgetsmart icon'} />
            </li>
          </ul>
        </div>
      </div>
      {ModalShowing && (
        <Modal onClose={() => setModalShowing(false)}>
          <div className="video-embed-wrap">
            <WistiaVideoEmbed
              wistiaID={isClayton ? 'kq1zhev3ag' : 'xjffah803m'}
              wistiaOptions="silentAutoPlay=false endVideoBehavior=reset autoPlay=true"
            />
          </div>
        </Modal>
      )}
      <img src={HouseSmartTopShape} alt="decorative shape" className="shape" />
    </HouseSmartTopStyles>
  );
};

export default HouseSmartTop;
